<template>
<div>



<div  style="font-size:1.2em " >
  <div  v-ripple   v-on:click='selectAll()' class=" meneg_item"><span   v-if=" likes.selector === false ">   Выбрать все </span> <span v-else > Отменить </span> </div>
  <div   v-ripple  v-on:click='copy()' class="meneg_item">Копировать</div>
  <div v-ripple   @click="update()"    class="meneg_item" > Обновить </div>
  <div v-ripple @click="deleteSelected()"  class="meneg_item" > Удалить </div>
  <div style="height:5px"></div>
  <v-divider></v-divider>
  <div v-ripple @click="changeCat()"  class="meneg_item" > Переместить </div>
  <div v-ripple @click="likes.modals.createCat = true"  class="meneg_item" > Создать список </div>

</div>







  <v-dialog v-model="toExport.dialog" scrollable max-width="300px">
      <v-card>
        <v-card-title> <v-icon medium left style="marginRight:5px"  >mdi-export</v-icon>   Экспорт {{this.groups.selected.length}} в задания</v-card-title>
        <v-divider></v-divider>
        <v-card-text fluid   style="height: 300px;">

          <div  v-if="toExport.loading && toExport.tasksList.length<1" class="text-xs-center">
<v-progress-circular

  :size="70"
  :width="7"
  color="#4A76A8"
  indeterminate
></v-progress-circular>
          </div>

          <div v-for=" item  in this.toExport.tasksList" >
          <v-checkbox v-model="tasks.selected"  v-bind ='[{label:item.name},{value:item.task_id}]'     ></v-checkbox>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A76A8" flat small   @click.native="toExport.dialog = false">Закрыть</v-btn>
          <v-btn v-if='tasks.selected.length>0' :loading="toExport.adding"  :disabled="toExport.adding" color="#4A76A8" small class="white--text"  @click="exportResources()">Выбрать</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>











<v-dialog v-model="likes.modals.createCat" persistent scrollable max-width="950px">
<v-card>
<v-toolbar height="42" flat dark color="#273C51">
<v-toolbar-title>Создать список </v-toolbar-title>
<v-spacer></v-spacer>
<v-icon style="cursor: pointer"  @click.native="likes.modals.createCat = false" >mdi-close</v-icon>
</v-toolbar>
<v-card-text fluid   style="height:500px;">
<v-select
label="Тип ресурсов" dense hide-details disabled
style="margin-bottom:0px"
:items="lists.source_types" v-model="lists.params.source_type" placeholder="Выберите тип ресурсов"
item-value = "key" item-text="label"
>
</v-select>
<v-text-field   v-model="lists.newListName" label="Придумайте название нового списка"></v-text-field>
<v-textarea v-model="lists.params.source_list" solo placeholder="IDS сообществ через запятую, не более 25 шт, по желанию."></v-textarea>

<v-autocomplete
v-model = "lists.params.task_list"
no-data-text = "Нет заданий для выбора"
:items="likes.taskList" hide-selected chips color="#4A76A8"
label="Выберите задания для экспорта новых лайков"
item-text="name" item-value="task_id" multiple
>
<template slot="selection" slot-scope="data">
<v-chip
:selected="data.selected" close class="chip--select-multi" @input="removeSelectedTaskForNewLikes(data.item)">
<v-avatar>
<v-icon>mdi-account-multiple</v-icon>
</v-avatar>
{{ data.item.name }}
</v-chip>
</template>

<template slot="item" slot-scope="data">
<v-list-tile-avatar>
<v-icon>mdi-account-multiple</v-icon>
</v-list-tile-avatar>
<v-list-tile-content>
<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
</v-list-tile-content>
</template>
</v-autocomplete>

<p style="color:#757575;font-size:1.3em">Постов с 1 ресурса</p>
<v-layout row style="margin-right:10px">
<v-flex class="px-3">
<v-subheader>Количество постов</v-subheader>
<v-slider v-model="lists.params.post_count" min="1" max="8" color="primary" thumb-label="always"></v-slider>
</v-flex>
</v-layout>

<p style="color:#757575;font-size:1.3em">Частота автообновления</p>
<v-layout row style="margin-right:10px">
<v-flex class="px-3">
<v-subheader>Секунды</v-subheader>
<v-slider v-model="lists.params.update_time.sec" min="1" max="59" color="primary" thumb-label="always"></v-slider>
</v-flex>

<v-flex class="px-3">
<v-subheader>Минуты</v-subheader>
<v-slider v-model="lists.params.update_time.min" max="59" color="primary" thumb-label="always"></v-slider>
</v-flex>

<v-flex class="px-3">
<v-subheader>Часы</v-subheader>
<v-slider max="23" v-model="lists.params.update_time.hours" color="primary" thumb-label="always"></v-slider>
</v-flex>
</v-layout>


</v-card-text>
<v-divider></v-divider>
<v-card-actions>
<v-spacer></v-spacer>
<v-btn style="text-transform:none" color="#273C51" flat small   @click.native="likes.modals.createCat = false">Отмена</v-btn>
<v-btn style="text-transform:none" v-if='lists.newListName.length>0 ' :loading="lists.loading"  :disabled="lists.loading" color="#273C51" small class="white--text"  @click="createList()"> <v-icon left>mdi-plus</v-icon> Создать список</v-btn>
</v-card-actions>
</v-card>
</v-dialog>


<v-dialog v-model="likes.modals.changeCatSelected" scrollable persistent max-width="450px">
<v-card>
<v-toolbar flat dark height="42" color="#273C51">
<v-toolbar-title >Переместить в список</v-toolbar-title>
<v-spacer></v-spacer>
<v-icon style="cursor: pointer"  @click.native="likes.modals.changeCatSelected = false" >mdi-close</v-icon>
</v-toolbar>
<v-card-text fluid   style="height: 300px;">
<v-select :items="likes.catList" v-model="lists.selectedForChange" label="Выберите существующий список">
<template slot="selection" >
<span >{{lists.selectedForChange.name}}</span>
</template>
<template v-slot:item="{ item, attrs, on }">
<span v-if="item !==likes.selectedCat"  >{{item.name}}</span>
<span style="color:gray" v-else>{{item.name}}</span>
</template>
</v-select>
</v-card-text>
<v-divider></v-divider>
<v-card-actions>
<v-spacer></v-spacer>
<v-btn style="text-transform:none" color="#273C51" flat small   @click.native="likes.modals.changeCatSelected = false">Отмена</v-btn>
<v-btn style="text-transform:none" v-if='lists.selectedForChange.name.length>0 ' :loading="lists.loading"  :disabled="lists.loading" color="#273C51" small class="white--text"  @click="changeCatList()">Переместить</v-btn>
</v-card-actions>
</v-card>
</v-dialog>


<v-snackbar v-model="sb.snackbar" :color="sb.color" center top :timeout="2000">
{{sb.text}}
<v-btn dark flat @click="sb.snackbar = false">ОК</v-btn>
</v-snackbar>

</div>
</template>




<script>
import axios from 'axios'
export default {
props : ['groups','likes'],
data(){
return {
css: {
marginTop: "10px"
},
lists:{
selectedForChange:{name:"",id:""},
params:{
source_type: "group",
source_list:"",
task_list:[],
update_time:{
  sec:30,
  min:0,
  hours:0
},
post_count:5,
},
newListName: "",
source_types:[
{key:"group",label:"Сообщества"},
{key:"page",label:"Страницы"}
],
loading : false,
adding: false,
},

     tasks:{
       selected:[]
     },
     sb:{
     snackbar: false,
     color: 'success',
     text: ''
   },
    toExport: {
      tasksList:[],
      dialog : false,
      loading: true,
      adding: false,

    }
   }
 },
methods : {
removeSelectedTaskForNewLikes(item){
const index = this.lists.params.task_list.indexOf(item.task_id)
if (index >= 0) this.lists.params.task_list.splice(index, 1)
},

createList(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/create_list.php', {
method: 'POST',
data: {
params: this.lists.params,
name:this.lists.newListName
}
})
.then( response => {
this.$router.push({query: { cat_id: response.data.cat_id }})
this.$router.go()
})
},

changeCat(){
if(this.likes.selectedSrc.length>0){
this.likes.modals.changeCatSelected = true
} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотя бы один источник лайков'
this.sb.snackbar = true
}
},

// переместить ресурсы из одной группы в другую
changeCatList(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/change_list.php',{
method: 'POST',
data: {
type: 'transfer',
newList: this.lists.selectedForChange,
src_ids: this.likes.selectedSrc
}
})
.then( response => {
this.$router.push({query: { cat_id: this.lists.selectedForChange.cat_id }})
this.$router.go()
})
},


update(){
if(this.likes.selectedSrc.length>0){
this.likes.checker.foundData.selector = false
this.likes.checker.foundData.foundIds = []
this.likes.checker.foundData.displayIds = []
this.likes.checker.foundData.selectedIds = []
this.likes.checker.foundData.offset = 0
this.likes.checkList = []

this.likes.selectedSrc.forEach( (item, i, arr)=>{ this.likes.checkList.push(item.id)})
this.likes.selectedSrc = []
this.likes.srcAll.forEach(function(item, i, arr){
item.add_info.selected = false
})
this.likes.modals.checkGroup = true
} else {
this.sb.color = 'error'
this.sb.text = 'что бы получить новые лайки, необходимо выбрать хотя бы один элемент'
this.sb.snackbar = true
}
},

deleteSelected(){
if(this.likes.selectedSrc.length>0){
this.likes.modals.deleteSelected = true
} else {
this.sb.color = 'error'
this.sb.text = 'Выберите один или несколько элементов'
this.sb.snackbar = true
}
},

selectAll(){
if(this.likes.selector ===  true){
this.likes.selectedSrc = []
this.likes.selector = false
this.likes.srcAll.forEach(function(item, i, arr){
item.add_info.selected = false
})
}
else {
this.likes.srcAll.forEach(function(item, i, arr){
item.add_info.selected = true
})
this.likes.selectedSrc = []
this.likes.selectedSrc =  this.likes.selectedSrc.concat(this.likes.srcAll)
this.likes.selector = true
}
},


copy(){
if(this.likes.selectedSrc.length>0){
let data = []
if(this.likes.selectedCat.params.source_type == 'group'){
  this.likes.selectedSrc.forEach(function(item, i, arr){
  data.push(item.id)
  })
}
const url = window.URL.createObjectURL(new Blob([data.join(',')]));
const link = document.createElement('a');
link.href = url;
link.setAttribute('download', 'groups.txt');
document.body.appendChild(link);
link.click()
navigator.clipboard.writeText(data.join(','))
.then ( ()=>{
this.sb.color = 'success'
this.sb.text = 'Скопированно '+this.likes.selectedSrc.length
this.sb.snackbar = true
}
)
} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотябы один элемент'
this.sb.snackbar = true
}

},

exportResources: function(){

     this.toExport.adding = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
       method: 'POST',
       data: {
       taskIds: this.tasks.selected,
       data: this.likes.selected
       }
     })
     .then( response => {
       console.log(response.data)
       this.toExport.adding = false
       this.toExport.dialog = false
       this.tasks.selected = []
       this.sb.color = 'success'
       this.sb.text = 'Успешный экспорт '+this.likes.selected.length
       this.sb.snackbar = true

     })
}



},
computed: {

}
 }
</script>



<style>
#meneger_wrapper{

  width: 250px;
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 2px 0 0 #d7d8db, 0 0 0 2px #e3e4e8;
  margin-left: 10px
}
#meneg_block {
position: relative;
background: #fff;
border-radius: 2px;
-webkit-box-shadow: 0 1px 0 0 #d7d8db, 0 0 0 1px #e3e4e8;
box-shadow: 0 1px 0 0 #d7d8db, 0 0 0 1px #e3e4e8;
margin: 15px 0 0;
}
.meneg_item{
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 32px;
    line-height: 31px;
    padding: 0 5px 0 20px;
    color: #2a5885;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    outline: none;
    cursor: pointer;
}

.meneg_item:hover{
  border-left: 3px solid #5181B8;
  padding: 0 5px 0 17px;
  background-color: #F0F2F5;
}

</style>
